<template>
  <div class="schedule">
    <top title="日程一览"></top>
    <div class="header-img" v-if="img_src">
      <img :src="img_src" @click="showTop = true"/>
      <van-image-preview v-model="showTop" :images="[img_src]" :showIndex="false">
      </van-image-preview>
    </div>
    <div class="timeTabs-wrap">
      <div class="timeTabs" v-if="theme_color">
        <div
          class="tab-item"
          @click="switchDate(-1)"
          :class="active==-1 ? 'active' : ''"
          :style="{background:(item==active?theme_color:'')}"
        >
          日程一览
        </div>
        <div
          class="tab-item"
          v-for="(item, index) in scheduleDate"
          :key="index"
          @click="switchDate(item)"
          :class="item == active ? 'active' : ''"
          :style="{background:(item==active?theme_color:'')}"
        >
          {{ item }}
        </div>
      </div>
      <div class="timeTabs" v-else>
        <div
          class="tab-item"
          @click="switchDate(-1)"
          :class="active==-1 ? 'active' : ''"
        >
          日程一览
        </div>
        <div
          class="tab-item"
          v-for="(item, index) in scheduleDate"
          :key="index"
          @click="switchDate(item)"
          :class="item == active ? 'active' : ''"
        >
          {{ item }}
        </div>
      </div>
    </div>
    <div v-if="active==-1">
      <img src="//cdn.edstatic.com/203012120000/03bda986582adb9d432bf9af5e5bd3ae/2022/11/e62769b7-a6aa-494e-8731-c2d37e2f3aea.jpg" style="width:100%" @click="showBig = true">
      <van-image-preview v-model="showBig" :images="['//cdn.edstatic.com/203012120000/03bda986582adb9d432bf9af5e5bd3ae/2022/11/e62769b7-a6aa-494e-8731-c2d37e2f3aea.jpg']" :showIndex="false" maxZoom="6">
      </van-image-preview>
    </div>
    <div class="content" v-else>
      <ul class="leftC">
        <li class="item" v-for="(item, index) in scheduleList" :key="index">
          <img :src="item.daily_preview_img" v-if="item.daily_preview_img"/>
          <p  v-else v-html="formatTitle(item.name)"></p>
        </li>
      </ul>
      <div class="rightC">
        <div class="sessionList">
          <div class="list" v-for="(value, index) in scheduleList" :key="index">
            <div
              class="item"
              v-for="(val, ind) in value.chapters"
              :key="ind"
              :style="{background:(theme_color?theme_color:'#d20202')}"
            >
            <router-link  
            :to="{
                path: '/vascularNews/meeting/liveDetail',
                query: { meeting_id: meeting_id, id: val.parallel_session_id,chapter_id:val.id},
              }">
              <h1>{{ val.start_at }}-{{ val.end_at }}</h1>
              <div style="margin-bottom:2px;">
                <img :src="val.daily_preview_img" v-if="val.daily_preview_img">
                <p class="line-clamp-3" v-else v-html="formatTitle(val.name)"></p>
              </div>
            </router-link>
              <img src="@/assets/images/cec2022/subscribe_schedule.png" style="width:50%;margin-top:4px;" @click.stop="subscribe(val)" v-if="val.is_preview==0&&val.allow_preview==1">
              <img src="@/assets/images/cec2022/has_subscribe.png" style="width:50%;margin-top:4px;" @click.stop="cancelSubscribe(val)" v-else-if="val.is_preview==1&&val.allow_preview==1">
            </div>
          </div>
        </div>
      </div>
    </div>
    <van-popup v-model="showQrcode" round>
      <div style="margin-top:10px;">
        <h2>我们将通过服务号提醒您观看直播</h2>
        <img src="@/assets/images/cec2022/qrcode.jpg" style="width:60%">
      </div>
      <h2 class="yellowbd">STEP1.请长按二维码关注服务号</h2>
      <h2 class="yellowbd" style="margin-bottom:10px;">STEP2.点击订阅按钮设置会议提醒</h2>
    </van-popup>
    <van-popup v-model="showChooseTime" round>
      <div style="margin-top:20px;">
        <h2>请选择在本场会议正式开始前</h2>
          <van-field
            readonly
            clickable
            name="picker"
            :value="pre_time"
            placeholder="点击选择时间"
            right-icon="arrow-down"
            @click="showPicker = true"
            style="width:100px;display: inline-block;vertical-align: bottom;border: 1px solid #DCDFE6;border-radius:5px;"
            />
          <span style="font-size:20px;line-height:46px;">分钟</span>
        <h2 style="margin-top:10px;">通过服务号消息提醒您观看直播</h2>
        <button @click.stop="submitSubscribe">确定</button>
      </div>
    </van-popup>
    <van-popup v-model="showPicker" position="bottom"  :style="{ height: '300px' }" >
		<van-picker
			show-toolbar
			:columns="columns"
			@confirm="onConfirm"
			@cancel="showPicker = false"
			 title="请选择时间" 
		/>
	</van-popup>
  </div>
</template>
<script>
import { MeetingsSchedule,ButtonDetail,isSubscribe,previewLive,cancelPreviewLive } from "../../config/interface.js";
import Top from "../VascularSystem/components/Top";
import  {Toast} from 'vant'
export default {
  components: {
    Top
  },
  data() {
    return {
      meeting_id: 0,
			button_id:this.$route.query.button_id?this.$route.query.button_id:this.$route.query.b_id,
      active: localStorage.getItem('cec_schedule')?localStorage.getItem('cec_schedule'):-1,
      meetingSchedule: [], //会议日程
      scheduleDate: [], //会议日期
      scheduleList: [], //日期对应的日程列表
      img_src: "",
      theme_color:"",
      showTop:false,
      showBig:false,
      is_subscribe:0,
      showQrcode:false,
      showPicker:false,
      showChooseTime:false,
      options:[
        {
          value:5,
          label:'5'
        },
        {
          value:15,
          label:'15'
        },
        {
          value:30,
          label:'30'
        }
      ],
      pre_time:5,
			columns:[5,15,30],
      subscribe_item:{}
    };
  },
  mounted() {
    this.meeting_id = this.$route.query.id;
    this.getSchedule();
    this.getSubscribeState();
  },
  methods: {
    getSchedule() {
      const url = MeetingsSchedule;
      let params = {
        meeting_id: this.meeting_id,
      };
      const method = "POST";
      fetch(url, params, method).then((res) => {
        if (res.code == 0) {
          var data = res.data;
          this.meetingSchedule = data.sessions;
          this.img_src = data.meeting.schedule_center_img;
          document.title=data.meeting.name;
          if(data.meeting.mission_set){
            this.theme_color=data.meeting.mission_set.color;
          }
          this.scheduleDate = Object.keys(this.meetingSchedule).sort();
          // this.scheduleDate = Object.getOwnPropertyNames(this.meetingSchedule);
          for (var i in this.meetingSchedule) {
            this.meetingSchedule[i].forEach((item, suffix) => {
              item.chapters.forEach((value, index) => {
                value.start_at = this.handleDate(value.start_at);
                value.end_at = this.handleDate(value.end_at);
              });
            });
          }
          let today=this.getToday();
          if(this.scheduleDate.indexOf(today)>-1){
            let index=this.scheduleDate.indexOf(today);
            this.switchDate(this.scheduleDate[index]);
          }
          else{
            if(this.active!=-1){
              this.switchDate(this.active);
            }
          }
          // else{
          //   this.switchDate(this.scheduleDate[0]);
          // }
          if(common.is_weixin()){
            if(this.button_id){
              this.getButtonData();
            }
            else{
							common.wxShare(data.meeting.name,data.meeting.title,data.meeting.shareimg);

            }
							
					}
        }
      });
    },
    //获取按钮信息
			getButtonData(){
				if(this.button_id){
					const url=ButtonDetail;
					let params={
              button_id:this.button_id
					}
					const method="POST";
					fetch(url,params,method)
					.then((res)=>{
						if(res.code==0){
							if(common.is_weixin()){
								let data=res.data;
								common.wxShare(data.share_title,data.share_sub_title,data.share_img);
							}
						}
					})

				}
			},
    getToday(){
      let date=new Date();
      let month=date.getMonth()+1;
      let day=date.getDate();
      let str=month+"月"+day+"日";
      // console.log(str);
      return str;

    },
    //切换日期
    switchDate(date) {
      this.active = date;
      if(date!=-1){
        this.scheduleList = this.meetingSchedule[date];
      }
      localStorage.setItem('cec_schedule',date);
    },
    //处理日期  09:30样式
    handleDate(date) {
      let time = date.split(" ")[1].split(":");
      return time[0] + ":" + time[1];
    },
    formatTitle(title){
      let strs=title.split(' ');
      let str='';
      for(let i=0;i<strs.length;i++){
        str=str+strs[i]+"<br/>";
      }
      return str;
    },
   getSubscribeState(){
      const url=isSubscribe;
      let params={};
      const method='POST';
      fetch(url,params,method)
      .then((res)=>{
          if(res.code==0){
              this.is_subscribe=res.data.subscribe
          }
      })
    },
    subscribe(item){
      this.subscribe_item=item;
      if(this.is_subscribe==1){
        this.showChooseTime=true;
      }
      else{
        Toast.loading({
            duration: 0,
            forbidClick: true,
            message: '',
        });
        const url=isSubscribe;
        let params={};
        const method='POST';
        fetch(url,params,method)
        .then((res)=>{
            Toast.clear();
            if(res.code==0){
                if(res.data.subscribe==0){
                  this.showQrcode=true
                }
                else{
                  this.is_subscribe=res.data.subscribe
                  this.showChooseTime=true;
                }
            }
        })
      }

    },
    submitSubscribe(){
        Toast.loading({
            duration: 0,
            forbidClick: true,
            message: '',
        });
        const url=previewLive;
        let params={
          meeting_id:this.meeting_id,
          type:0,
          time:this.pre_time,
          id:this.subscribe_item.id

        };
        const method='POST';
        fetch(url,params,method)
        .then((res)=>{
            Toast.clear();
            if(res.code==0){
               this.subscribe_item.is_preview=1;
                this.showChooseTime=false;
            }
            else {
							common.toast( res && res.error_msg ? res.error_msg : "未知错误",1000,'fail',()=>{})
						}
        })
    },
    cancelSubscribe(val){
      Toast.loading({
            duration: 0,
            forbidClick: true,
            message: '',
        });
        const url=cancelPreviewLive;
        let params={
          meeting_id:this.meeting_id,
          type:0,
          id:val.id
        };
        const method='POST';
        fetch(url,params,method)
        .then((res)=>{
            Toast.clear();
            if(res.code==0){
               val.is_preview=0;
            }
            else {
							common.toast( res && res.error_msg ? res.error_msg : "未知错误",1000,'fail',()=>{})
						}
        })
    },
    onConfirm(val){
      this.pre_time=val;
      this.showPicker=false
		}
  },
};
</script>
<style lang="scss" scoped>
.schedule {
  .header-img {
    img {
      width: 100%;
      display: block;
    }
    // height: 70px;
  }
  .timeTabs-wrap {
    overflow: hidden;
    width: 100%;
    background: #fff;
  }
  .timeTabs {
    padding: 10px 12px;
    // height: 60px;
    // @include flex(row);
    align-items: center;
    width: 100%;
    border-bottom: 1px solid #bfbfbf;
    white-space: nowrap;
    overflow-x: auto;
    .tab-item {
      display: inline-block;
      font-size: 14px;
      color: #666;
      width: 70px;
      height: 30px;
      text-align: center;
      line-height: 30px;
      border: 1px solid #666;
      border-radius: 2px;
      margin: 5px 15px 5px 0;
      // margin-right: 15px;
      // margin-bottom: 10px;
      // margin-top:10px;
    }
    .active {
      color: #fff;
      background: #d20202;
      border: 0px;
    }
  }
  .timeTabs::-webkit-scrollbar {
    display: none;
  }
  .content {
    padding: 15px 0;
    background-color: #f1f2f4;
    height: calc(100vh - 110px);
    // overflow: auto;
    .leftC {
      float: left;
      width: 27%;
      padding: 0 12px;
      // position: fixed;
      .item {
        padding: 5px; /* no */
        display: -webkit-box;
        box-sizing: border-box;
        width: 77px;
        background: #ffffff;
        border-radius: 3px;
        height: 94px;
        // display:flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        font-size: 14px; /* no */
        letter-spacing: 0.5px;
        color: #090909;
        margin-bottom: 30px;
        text-align: center;
        img{
          height: 100%;
        }
      }
    }
    .rightC {
      overflow-x: auto;
      float: left;
      width: 73%;
      .list {
        display: -webkit-box;
      }
      .item {
        display: block;
        box-sizing: border-box;
        background: #d20202;
        border-radius: 3px;
        width: 110px;
        height: 94px;
        padding: 6px;
        margin: 0 5px 30px 0;
        text-align: center;
        img{
          width: 100%;
        }
        h1 {
          font-weight: normal;
          text-align: center;
          font-size: 12px;
          color: #ffffff;
          letter-spacing: 0.42px;
        }
        div {
          padding: 5px;
          border-radius: 3px;
          background: #fff;
          margin-top: 6px;
          height: 60px;
          display: flex;
          align-items: center;
          justify-content: center;
          p {
            word-break: break-all;
            font-size: 12px;
            color: black;
            letter-spacing: 0.42px;
          }
        }
      }
    }
  }
  .content:after {
    display: block;
    content: "";
    clear: both;
  }
}
.van-popup{
  padding: 0 20px;
  text-align: center;
  color: #a21016;
  background-image: url('../../assets/images/cec2022/med_conference.png');
  background-size: 80% auto;;
  background-position: 100% 40%;
  background-repeat: no-repeat;
  h2{
    margin: 5px  0;
	padding: 0 10px;
    white-space: nowrap;
  }
  .yellowbd{
	border: 3px solid #ce9f70;
	border-radius: 15px;
  }
  button{
	margin:10px 0;
	padding:0px 40px;
	border: 3px solid #ce9f70;
	background: white;
	font-weight:500;
	color:#a21016;
	border-radius: 20px;
	font-size: 16px;
	line-height: 36px;
  }
  /deep/.van-popup__close-icon--top-right{
    top: 0 !important;
    right: 0 !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/cec2022/schedule.vue